import { Box, Button } from '@mui/material'
import styles from './index.module.scss'

export default function UserChatBubbleEditSurface({
  draftText,
  onDraftTextChange,
  onCancelEdit,
  onSendEdit,
}) {
  return (
    <>
      <Box className={styles.editCard}>
        <Box className={styles.editBody}>
          <Box
            component="textarea"
            className={styles.editTextarea}
            value={draftText}
            onChange={(e) => onDraftTextChange?.(e.target.value)}
            aria-label="Message editor"
            autoFocus
          />
        </Box>
      </Box>
      <Box className={styles.editActions}>
        <Button
          type="button"
          className={`${styles.pillButton} ${styles.pillButtonCancel}`}
          onClick={() => onCancelEdit?.()}
        >
          Cancel
        </Button>
        <Button
          type="button"
          className={`${styles.pillButton} ${styles.pillButtonSend}`}
          variant="contained"
          onClick={() => onSendEdit?.()}
        >
          Save
        </Button>
      </Box>
    </>
  )
}
